require('../../modules/es6.math.cosh');
module.exports = require('../../modules/_core').Math.cosh;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/cosh.js
// module id = Nnon
// module chunks = 0